import React from "react"
import { useDispatch } from 'react-redux';
import { setIsOpen as setIsMobileOpen } from '../Actions/Navigation.action';

export default function NavigationMobileToggleButton() {
    const dispatch = useDispatch()

    const show = () => {
        dispatch(setIsMobileOpen(true))
    }

    return <i className="icon icon-menu" onClick={show}></i>
}